// extracted by mini-css-extract-plugin
export default {"badge":"vacationArchiveOther_badge__srjlu"};